module.exports = __webpack_public_path__ + "img/aeroland-payment-box-icon-02.a4f0ecb4.png";